export default "__VITE_ASSET__ClmsZYLi__"